import { apiPath } from './api.path';
import { instance } from './axios';

async function addReferenceAPI(params) {
  return instance.post(apiPath.addReference, params).then((response) => response.data);
}

async function getReferenceAPI(params) {
  return instance.get(apiPath.getReference, params).then((response) => response.data);
}

async function getStaticPagesAPI() {
  return instance.get(apiPath.getStaticPages).then((response) => response.data);
}

const utilService = {
  addReferenceAPI,
  getReferenceAPI,
  getStaticPagesAPI
};

export default utilService;
